import React from "react";
import styled from "styled-components";

const G = styled.g`
  stroke: ${props => props.theme.primary};
`;

const ServicesDropdownIcon = () => {
  if (window.innerWidth > 1800)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.004"
        height="21.87"
        viewBox="0 0 24.004 21.87"
      >
        <G
          transform="translate(0 .75)"
          fill="none"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        >
          <g transform="translate(1.299 1.587)">
            <path
              d="M13.677,24.44V20.049a5.889,5.889,0,1,0-11.777,0V24.44A16.686,16.686,0,0,0,13.677,24.44Z"
              transform="translate(-1.9 -6.746)"
            />
            <circle
              cx="3.461"
              cy="3.461"
              r="3.461"
              transform="translate(2.428)"
            />
          </g>
          <g transform="translate(13.234)">
            <path
              d="M28.2,15.723V13.555a4.425,4.425,0,1,0-8.85,0V15.73"
              transform="translate(-19.35 -3.57)"
            />
            <circle
              cx="2.599"
              cy="2.599"
              r="2.599"
              transform="translate(1.826)"
            />
          </g>
          <line x1="2.387" transform="translate(0 11.476)" />
          <path
            d="M17.52,17.78H28.791v9.644"
            transform="translate(-5.537 -6.304)"
          />
        </G>
      </svg>
    );
  else
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17.5"
        height="15.94"
        viewBox="0 0 17.5 15.94"
      >
        <G
          transform="translate(-948.5 -191.5)"
          fill="none"
          strokeMiterlimit="10"
        >
          <path
            d="M10.51,21.675v-3.21a4.305,4.305,0,0,0-8.61,0v3.21A12.2,12.2,0,0,0,10.51,21.675Z"
            transform="translate(947.55 184.42)"
          />
          <circle
            cx="2.53"
            cy="2.53"
            r="2.53"
            transform="translate(951.225 193.16)"
          />
          <path
            d="M25.82,13.95V12.365a3.235,3.235,0,1,0-6.47,0v1.59"
            transform="translate(938.825 186.935)"
          />
          <circle cx="1.9" cy="1.9" r="1.9" transform="translate(959.51 192)" />
          <line x1="1.745" transform="translate(948.5 200.39)" />
          <path
            d="M17.52,17.78h8.24v7.05"
            transform="translate(939.74 182.61)"
          />
        </G>
      </svg>
    );
};

export default ServicesDropdownIcon;
